// extracted by mini-css-extract-plugin
module.exports = {"root":"RulesPage_root__3TQXa","container":"RulesPage_container__17jEJ","pageTitle":"RulesPage_pageTitle__2u08k","rulesContent":"RulesPage_rulesContent__1K_h0"};